import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';

export default ChevronLeftRoundedIcon;
